import { FilterQuery } from '@yes.technology/react-toolkit'
import isEqual from 'lodash/isEqual'
import merge from 'lodash/merge'
import { useRef } from 'react'

type UseMergedFilterQueryProps = {
  filterQuery?: FilterQuery
  manifestFilterQuery?: FilterQuery
}

const useMergedFilterQuery = ({
  filterQuery,
  manifestFilterQuery
}: UseMergedFilterQueryProps): FilterQuery | undefined => {
  const prevFilterQueryRef = useRef<FilterQuery | undefined>(undefined)
  const prevManifestFilterQueryRef = useRef<FilterQuery | undefined>(undefined)
  const resultRef = useRef<FilterQuery | undefined>(undefined)

  const filterQueryChanged = !isEqual(prevFilterQueryRef.current, filterQuery)
  const manifestFilterQueryChanged = !isEqual(
    prevManifestFilterQueryRef.current,
    manifestFilterQuery
  )

  if (filterQueryChanged || manifestFilterQueryChanged) {
    prevFilterQueryRef.current = filterQuery
    prevManifestFilterQueryRef.current = manifestFilterQuery

    resultRef.current =
      filterQuery || manifestFilterQuery
        ? merge({}, filterQuery, manifestFilterQuery)
        : undefined
  }

  return resultRef.current
}

export default useMergedFilterQuery
